import React, {Component, createRef} from "react";
import {connect} from "react-redux";
import FJUploadImage from "../view/FJUploadImage";
import FJWatermarkAction from "../../../redux/action/FJWatermark.action";
import FJWatermarkImageBox from '../view/FJWatermarkImageBox'
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJActionConstant from "../../../constant/FJActionConstant";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import FJEventConstant from "../../../constant/FJEventConstant";

class FJWatermarkImageViewContainer extends Component{

	constructor(props) {
		super(props);

		this.state = {
			inputFile: createRef(),
			acceptType: FJCoreUtil.getBrowser() === 'Safari' ? 'image/*' : 'image/*',
		}
	}

	componentDidMount() {
	  window.FJEvent.subscribe(FJEventConstant.UPDATE_WATERMARK, () => {
	    this.props.updateWatermark();
    });

    this.props.updateWatermark();
  }

  /**
	 * @description 选择文件上传
	 * @param e
	 * @private
	 */
	onChange = (e) => {
		this.props.uploadWatermarkFileAction(e.target.files[0])
	};

	/**
	 * @description 点击上传按钮触发文件上传
	 * @private
	 */
	uploadBtnClick = () => {
		this.state.inputFile.current.click();
	};

	_onDragOver = (e) => {
		window.RC.isFJDragging = true;
		e.dataTransfer.dropEffect = window.RC.hasModal ? 'none' : 'drop';
		this.props.changeDragMode(FJActionConstant.DRAG_FILE_MODE_RESOURCE);
	}

	_onDragLeave = (e) => {
		window.RC.isFJDragging = false;
		if (this.timer) {
			clearTimeout(this.timer);
		}
		e.preventDefault();
		e.stopPropagation();
		this.timer = setTimeout(() => {
			if (!window.RC.isFJDragging) {
				this.props.changeDragMode(null);
			}
		}, 100);
	}

	_onDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
		window.RC.isFJDragging = false;
		this.props.changeDragMode(null);
		let files = e.dataTransfer && e.dataTransfer.files;
		this.props.uploadWatermarkFileAction(files[0]);
	}

	render() {

		const {
			inputFile,
			acceptType,
		} = this.state;

		const {
			isShow,
      watermarkImageUrl,
      watermarkSize,
      watermarkOpacity,
      setWatermarkParams,
      watermarkPosition,
			onRemove,
			dragFileMode,
      watermarkImageProgress,
      watermarkImageStatus,
      retryWatermark,
			isExistWaterImage
		} = this.props;

		return (
      <div style={{display: isShow ? 'block' : 'none'}}>
				<FJUploadImage active={!isExistWaterImage}
											 inputFile={inputFile}
											 onChange={this.onChange}
											 acceptType={acceptType}
											 uploadBtnClick={this.uploadBtnClick}
											 onDragOver={this._onDragOver}
											 onDragLeave={this._onDragLeave}
											 onDrop={this._onDrop}
											 dragFileMode={dragFileMode}
				/>
				<FJWatermarkImageBox active={isExistWaterImage}
                             watermarkImageProgress={watermarkImageProgress}
                             watermarkSize={watermarkSize}
                             watermarkOpacity={watermarkOpacity}
                             setWatermarkParams={setWatermarkParams}
                             watermarkPosition={watermarkPosition}
														 onRemove={onRemove}
                             url={watermarkImageUrl}
														 inputFile={inputFile}
														 onChange={this.onChange}
														 acceptType={acceptType}
														 onUpload={this.uploadBtnClick}
														 retry={retryWatermark}
														 thumbnailStatus={watermarkImageStatus}
				/>
			</div>
		)
	}

}

const mapStateToProps = function (state) {
	return {
    watermarkImageUrl: state.watermark.watermarkImageUrl,
    watermarkSize: state.watermark.watermarkSize,
    watermarkOpacity: state.watermark.watermarkOpacity,
    watermarkPosition: state.watermark.watermarkPosition,
		dragFileMode: state.media.dragFileMode,
		isExistWaterImage: state.watermark.isExistWaterImage,
    watermarkImageStatus: state.watermark.watermarkImageStatus,
		watermarkImageProgress: state.watermark.watermarkImageProgress
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
    setWatermarkParams: function (type, data) {
      dispatch(FJWatermarkAction.setWatermarkParamsAction(type, data));
    },
		changeDragMode: function (data) {
			dispatch(FJMediaAction.changeDragModeAction(data));
		},
		onRemove: function () {
    	dispatch(FJWatermarkAction.removeWatermarkImageAction())
		},
		uploadWatermarkFileAction: function (file) {
			dispatch(FJWatermarkAction.uploadWatermarkAction(file))
		},
    retryWatermark: function () {
      dispatch(FJWatermarkAction.retryWatermarkActon());
    },
    setWatermarkProgress: function (value) {
      dispatch(FJWatermarkAction.setWatermarkProgressAction(value));
    },
    updateWatermark: function () {
      dispatch(FJWatermarkAction.updateWatermarkAction());
    }
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJWatermarkImageViewContainer);
